import { useDropEvent, useUserCampaignData } from 'root/src/client/logic/dropEvent/hooks/useDropEvent';
import { DarePlatform } from 'root/src/shared/@types/platforms';
import { useConnectedPlatformsByDares } from 'root/src/client/logic/dropEvent/hooks/useConnectedPlatformsByDares';
import { calculateMaxDaresByPlatform } from 'root/src/shared/util/calculateMaxDares';
import { useCreatorFollowersCountByPlatform, useUserCreatorData } from 'root/src/client/logic/auth/hooks/useUser';
import { getClassifiedDarePlatform } from 'root/src/shared/drops/helpers/dropDare.helpers';
import { isPlatform } from 'root/src/shared/platforms/guards/platform.guards';
export function useIsMaxDaresReachedByPlatforms(params = {}) {
    var _a;
    const { platforms = Object.values(DarePlatform), recordId, fallbackDrop } = params;
    const dropEvent = (_a = useDropEvent(recordId)) !== null && _a !== void 0 ? _a : fallbackDrop;
    const userCampaignData = useUserCampaignData(recordId);
    const connectedPlatformsByDares = useConnectedPlatformsByDares(recordId, fallbackDrop);
    const { averageCcv } = useUserCreatorData();
    const followerCountByPlatform = useCreatorFollowersCountByPlatform();
    if (!dropEvent) {
        return false;
    }
    if (!connectedPlatformsByDares.length) {
        return false;
    }
    return platforms.every((darePlatform) => {
        const darePlatformClassified = getClassifiedDarePlatform(darePlatform);
        if (!darePlatformClassified) {
            return false;
        }
        const maxDares = calculateMaxDaresByPlatform({
            platform: darePlatformClassified,
            averageCcv: averageCcv || 0,
            followerCount: followerCountByPlatform[darePlatformClassified],
            campaign: dropEvent,
        });
        if (!maxDares) {
            return true;
        }
        return isMaxDaresReachedByPlatform({ dropEvent, maxDares, platform: darePlatform, userCampaignData });
    });
}
export function isMaxDaresReachedByPlatform({ maxDares, dropEvent, platform, userCampaignData }) {
    var _a, _b, _c;
    const { dares, creatorAcceptedDaresByPlatform } = dropEvent;
    const platformClassified = isPlatform(platform) ? platform : getClassifiedDarePlatform(platform);
    const userAcceptedDaresCount = platformClassified
        ? (_c = (_a = creatorAcceptedDaresByPlatform === null || creatorAcceptedDaresByPlatform === void 0 ? void 0 : creatorAcceptedDaresByPlatform[platformClassified]) !== null && _a !== void 0 ? _a : (_b = userCampaignData === null || userCampaignData === void 0 ? void 0 : userCampaignData.creatorAcceptedDaresByPlatform) === null || _b === void 0 ? void 0 : _b[platformClassified]) !== null && _c !== void 0 ? _c : 0
        : 0;
    const userMaxDares = Math.min(maxDares, dares.length);
    const isAnyDareAccepted = userAcceptedDaresCount > 0;
    return isAnyDareAccepted && (userMaxDares - userAcceptedDaresCount <= 0);
}
